import { useLocalObservable } from 'mobx-react-lite'
import { Container } from '@/utils/sparrowContainer'
import { useEffect } from 'react'
import { reaction } from 'mobx'
import { globalStore } from '@/GlobalStore'
import useDelivery from '../hooks/useDelivery'
import {UserInfo} from '../hooks/useUser'
import useFormatData from '../hooks/useFormatData'

type Store = {
  userInfos: UserInfo[]
  userRecord: Record<string, UserInfo>
}

type Props = Store

function useUserContext(initState: Record<string, string>): Props {
  const store = useLocalObservable<Store>(() => ({
    userInfos: [],
    userRecord: {}
  }))
  const { getAllUserList } = useDelivery()
  const { arrayToObject } = useFormatData()

  useEffect(() => {
    const loadUsers = () => {
      if (!globalStore.isLoggedIn || !globalStore.currentTeamId) {
        return
      }
      getAllUserList().then((res) => {
        if (!res) return
        store.userInfos = res
        store.userRecord = arrayToObject<UserInfo>(
          res.map((u) => ({ ...u, id: String(u.id) })),
          'id'
        )
      })
    }
    loadUsers()
    const dispose = reaction(
      () => globalStore.currentTeamId,
      () => loadUsers()
    )
    return () => dispose()
  }, [])

  return Object.assign(store)
}

export default Container.createContainer<Props, Record<string, string>>(
  useUserContext
)
